import { gql } from '@apollo/client';

/**
 * The Scorecard tab. What each number means is in the backend's
 * docs/RETENTION_SCORECARD.md.
 */

const VALUE = `from to value numerator denominator`;

export const REPORT_SCORECARD = gql`
  query reportScorecard($input: ScorecardInput!) {
    reportScorecard(input: $input) {
      today
      timezone
      current { from to }
      previous { from to }
      metrics {
        key
        section
        label
        description
        unit
        headline
        higherIsBetter
        target
        settlesAfterDays
        shiftedDays
        current { ${VALUE} }
        previous { ${VALUE} }
        trend { ${VALUE} }
      }
    }
  }
`;

const CURVE_COHORT = `
  cohort
  members
  months { month eligible retained rate }
`;

export const REPORT_RETENTION_CURVE = gql`
  query reportRetentionCurve($input: RetentionCurveInput) {
    reportRetentionCurve(input: $input) {
      since
      overall { ${CURVE_COHORT} }
      cohorts { ${CURVE_COHORT} }
    }
  }
`;

export const REPORT_RETENTION_DRIVERS = gql`
  query reportRetentionDrivers($input: ReportScopeInput) {
    reportRetentionDrivers(input: $input) {
      from
      to
      members
      kept
      baseRate
      signals {
        key
        label
        withMembers
        withKept
        withRate
        withoutMembers
        withoutKept
        withoutRate
        lift
      }
      scores { score andAbove members kept rate }
    }
  }
`;
